import { createContext } from 'react';

const logContext = createContext();

export default logContext;